// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__BMHlc","breadcrumbLink":"Breadcrumb_breadcrumbLink__mp2Ln","breadcrumbText":"Breadcrumb_breadcrumbText__BVOsc"};